import { IssueChart } from 'shared/types/analytics';
import { IssueChartFilterKind } from './issueChartFilterKind';

const {
  originators,
  process,
  sites,
  workType,
  impact,
  assignee,
} = IssueChartFilterKind;

/**
 * The filters of each issue chart, in order after the date range. Saved and
 * sent filters keep only their values, read back by position: never reorder
 * a chart's filters, add new ones at its end.
 */
export const ISSUE_CHART_FILTER_KINDS: Readonly<Record<IssueChart, readonly IssueChartFilterKind[]>> = {
  [IssueChart.impact]: [originators, process, sites, workType, assignee, impact],
  [IssueChart.hsHazardType]: [originators, sites, workType, assignee, impact, process],
  [IssueChart.hsEffect]: [originators, sites, workType, assignee, impact, process],
  [IssueChart.environmentalAspect]: [originators, impact, sites, workType, assignee, process],
  [IssueChart.rootCause]: [originators, process, sites, workType, impact, assignee],
  [IssueChart.workType]: [process, sites, originators, impact, assignee, workType],
  [IssueChart.originator]: [process, sites, workType, impact, assignee, originators],
};
